export default {
  'menu.概览': '概览',
  'menu.客户关系': '客户关系',
  'menu.客户关系.客户主体': '客户主体',
  'menu.客户关系.联系人': '联系人',
  'menu.客户关系.机构': '机构',
  'menu.已投项目': '已投项目',
  'menu.已投项目.全部项目': '全部项目',
  'menu.已投项目.我的项目': '我的项目',
  'menu.已投项目.项目详情': '项目详情',
  'menu.经营跟踪': '经营跟踪',
  'menu.经营跟踪.经营看板': '经营看板',
  'menu.经营跟踪.数据记录': '数据记录',
  'menu.经营跟踪.记录详情': '记录详情',
  'menu.风险与事项': '风险与事项',
  'menu.风险与事项.风险台账': '风险台账',
  'menu.风险与事项.风险详情': '风险详情',
  'menu.风险与事项.重点事项': '重点事项',
  'menu.风险与事项.事项详情': '事项详情',
  'menu.赋能与服务': '赋能与服务',
  'menu.赋能与服务.赋能事项': '赋能事项',
  'menu.赋能与服务.赋能详情': '赋能详情',
  'menu.赋能与服务.资源协同': '资源协同',
  'menu.赋能与服务.资源详情': '资源详情',
  'menu.赋能与服务.增值服务': '增值服务',
  'menu.赋能与服务.服务详情': '服务详情',
  'menu.定期报告': '定期报告',
  'menu.定期报告.报告列表': '报告列表',
  'menu.定期报告.分析专题': '分析专题',
  'menu.定期报告.报告详情': '报告详情',
  'menu.设置': '设置',
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings': '系统设置',
  'menu.settings.permissions': '权限管理',
  'menu.settings.modelSettings': '模型设置',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
